import { render, staticRenderFns } from "./NuevoMovimientoBasico.vue?vue&type=template&id=5059d27b&scoped=true&"
import script from "./NuevoMovimientoBasico.vue?vue&type=script&lang=js&"
export * from "./NuevoMovimientoBasico.vue?vue&type=script&lang=js&"
import style0 from "./NuevoMovimientoBasico.vue?vue&type=style&index=0&id=5059d27b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5059d27b",
  null
  
)

export default component.exports